import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public static USER_KEY: string = "_dsessionInfo";
  public static ID_CIA_ADMIN: number = 5;

  constructor() { }

  setData(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  getData(key: string) {
    return localStorage.getItem(key);
  }

  public static setData_v2(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  public static getData_v2(key: string) {
    return localStorage.getItem(key);
  }


  public static setAll(value: any) {
    localStorage.setItem(this.USER_KEY, value);
  }

  public static getSession() {
    return localStorage.getItem(this.USER_KEY);
  }

  public static obtenerAcceso(accesos: any, codmod: number, codacc: number): any {
    let vResponse: any = null;
    if (accesos != null)
      accesos.forEach((element: any) => {
        if (element.codmod == codmod && element.codacc == codacc) {
          vResponse = element;
        }
      });
    return vResponse
  }

  removeData(key: string) {
    localStorage.removeItem(key);
  }

  public static clearStorage() {

    var keys = Object.keys(localStorage)
    var count = keys.length;

    while (count--) {
      keys[count] == 'versionApp' || keys[count] == 'login' ? null : localStorage.removeItem(keys[count])
    }


  }
}